import { ALL_VALE_PROJECTS, CUIA_PROJECTS, SEMPROR_PROJECTS } from "../vale/projectList";

export const filterProjects = (projects) => {
  const AMBEV_PROJECTS = [
    '92f90be5-c7f5-496b-844e-70281d033b3e',
    '1434575c-eb9f-40e6-a35a-df630c5474fc',
    '903888ae-0451-4298-b5dd-88f2df9b2324',
    '9995766a-8c5b-4503-a0ac-106974b3be8b',
    '8c71eb40-8c39-4060-85cb-d67d0394fb1f',
    'e188b55a-ccbe-438e-886a-b2bcb01291ae',
    'c165104a-6d2e-4a49-808c-b5edd1133345',
    '77803995-074b-48b9-932e-50e83a380941',
    '314a9c0b-6bb5-4331-ac41-157e63fd821a',
    '599b961e-d7f8-4634-bbef-93fdebc81942',
    '78bdb57b-abbd-46ad-84c9-83697d4f6b93',
    '3ac327ae-87d5-463e-b5c7-0ce54fa205d9',
    '7545f50b-5ab5-462c-82c6-92719c990c03'
  ];

  const hasAmbevProject = projects.filter(project =>
    AMBEV_PROJECTS.filter(item => item.includes(project.value))[0]
  );

  const hasSemprorProject = projects.filter(project =>
    SEMPROR_PROJECTS.filter(item => item.includes(project.value))[0]
  );

  const hasAllValeProject = projects.filter(project =>
    ALL_VALE_PROJECTS.filter(item => item.includes(project.value))[0]
  );

  const hasCuiaProject = projects.filter(project =>
    CUIA_PROJECTS.filter(item => item.includes(project.value))[0]
  )

  if(hasAmbevProject.length || hasSemprorProject.length || hasAllValeProject.length || hasCuiaProject.length) {
    return [
      ...projects.filter(project => 
        !AMBEV_PROJECTS.filter(item => item.includes(project.value))[0] &&
        !SEMPROR_PROJECTS.filter(item => item.includes(project.value))[0] &&
        !ALL_VALE_PROJECTS.filter(item => item.includes(project.value))[0] &&
        !CUIA_PROJECTS.filter(item => item.includes(project.value))[0]
      ),
      hasAmbevProject.length ? {value: AMBEV_PROJECTS.map(item => `'${item}'`).toString(), label: "Ambev" } : {},
      hasSemprorProject.length ? {value: SEMPROR_PROJECTS.map(item => `'${item}'`).toString(), label: "SEMPROR" } : {},
      hasAllValeProject.length ? {value: ALL_VALE_PROJECTS.map(item => `'${item}'`).toString(), label: "Vale" } : {},
      hasCuiaProject.length ? {value: CUIA_PROJECTS.map(item => `'${item}'`).toString(), label: "CUIA" } : {},
    ].filter(item => item?.value).sort((a,b) => {
      if(a?.label < b?.label) { return -1; }
      if(a?.label > b?.label) { return 1; }
      return 0;
    });
  }

  return projects;
}

export const isAmbevProjects = (projectId) => {
  const data = [
    '92f90be5-c7f5-496b-844e-70281d033b3e',
    '1434575c-eb9f-40e6-a35a-df630c5474fc',
    '903888ae-0451-4298-b5dd-88f2df9b2324',
    '9995766a-8c5b-4503-a0ac-106974b3be8b',
    '8c71eb40-8c39-4060-85cb-d67d0394fb1f',
    'e188b55a-ccbe-438e-886a-b2bcb01291ae',
    'c165104a-6d2e-4a49-808c-b5edd1133345',
    '77803995-074b-48b9-932e-50e83a380941',
    '314a9c0b-6bb5-4331-ac41-157e63fd821a',
    '599b961e-d7f8-4634-bbef-93fdebc81942',
    '78bdb57b-abbd-46ad-84c9-83697d4f6b93',
    '3ac327ae-87d5-463e-b5c7-0ce54fa205d9',
    '7545f50b-5ab5-462c-82c6-92719c990c03'
  ]

  if(Array.isArray(projectId)) {
    return data.find(project => projectId.map(row => row?.value || row).find(row => row === project))    
  }

  return data.includes(projectId)
}